export const LoanColumns = [
  { id: "actions", title: "Actions" },
  { id: "partyName", title: "Party" },
  { id: "phone", title: "Phone" },
  { id: "amount", title: "Total given" },
  { id: "paidAmount", title: "Received back" },
  { id: "balance", title: "Balance" },
  { id: "status", title: "Status" },
  { id: "date", title: "Last loan" },
];

export const LoanDisbursementColumns = [
  { id: "date", title: "Date" },
  { id: "amount", title: "Amount" },
  { id: "accountId", title: "Paid from" },
  { id: "desc", title: "Notes" },
  { id: "actions", title: "Actions" },
];
